module.exports = __webpack_public_path__ + "img/sidebar-left.e32e22bb.svg";